import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info-cost-out',
  templateUrl: './info-cost-out.component.html',
  styleUrls: ['./info-cost-out.component.scss']
})
export class InfoCostOutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
